var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOldestFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 8.75033C8.32611 8.32891 9.41634 6.66699 9.99984 6.66699M9.99984 6.66699C10.5833 6.66699 11.6736 8.32891 12.0832 8.75033M9.99984 6.66699V13.3337",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 10.0007C2.08301 6.2687 2.08301 4.40273 3.24237 3.24335C4.40175 2.08398 6.26772 2.08398 9.99967 2.08398C13.7316 2.08398 15.5976 2.08398 16.757 3.24335C17.9163 4.40273 17.9163 6.2687 17.9163 10.0007C17.9163 13.7326 17.9163 15.5986 16.757 16.758C15.5976 17.9173 13.7316 17.9173 9.99967 17.9173C6.26772 17.9173 4.40175 17.9173 3.24237 16.758C2.08301 15.5986 2.08301 13.7326 2.08301 10.0007Z",
    stroke: "#616874",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldestFirst);
export default __webpack_public_path__ + "static/media/oldest-first.ada7a36a69e6e84759e21684049fb0f0.svg";
export { ForwardRef as ReactComponent };